import { Divider, CircularProgress, Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React, { useEffect, useState } from 'react';
import ChildCard from '../../../shared/ChildCard';
import { useDispatch } from 'react-redux';
import BackButton from '../../../shared/button/BackButton';
import ErrorView from 'src/components/errors/ErrorView';
import ReservationInfo from './ReservationInfo';
import SummarySection from './SummarySection';
import { useParams } from 'react-router';
import { useMsal } from '@azure/msal-react';
import { changeDetailView, fetchReservationById, fetchClientVoucherDetailsList } from 'src/store/reservations/slices/ReservationsManagerSlice';
import { setReservationOverviewVisibility } from 'src/store/reservations/slices/hotels/HotelDetailSlice';
import ManageTabItem from './ManageTabItem';
import MyReservationsOverviewSkeleton from './MyReservationsOverviewSkeleton';

const MyReservationsOverview = () => {
	const { id } = useParams();
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true);
	const { instance, accounts } = useMsal();
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoading(true);
				dispatch(changeDetailView(true));
				await dispatch(fetchReservationById(instance, accounts, id));
				await dispatch(fetchClientVoucherDetailsList(instance, accounts, id));
			} catch (error) {
				setError(error);
			} finally {
				setLoading(false);
			}
		};

		if (id) {
			fetchData();
		}
	}, [id, dispatch, instance, accounts]);

	const handleClick = () => {
		dispatch(setReservationOverviewVisibility(false));
	};

	const handleClose = () => {
		setError(null);
	};

	return (
		<ChildCard sx={{ p: 3, borderRadius: 2, boxShadow: 1 }}>
			{loading ? (
				<MyReservationsOverviewSkeleton />
			) : (
				<>
					{(error) && (
						<ErrorView
							error={error}
							onClose={handleClose}
						/>
					)}
					<ReservationInfo />
					<Divider sx={{ my: 3 }} />
					<SummarySection />
					<ManageTabItem setError={setError} />

					<Grid size={12} mt={5}>
						<BackButton onClick={handleClick} to={`/reservations/my`} />
					</Grid>
				</>
			)}
		</ChildCard>
	);
};

export default MyReservationsOverview;